import { invariant } from '@apollo/client/utilities/globals'
import { useMemo } from 'react'

import useCurrentAuth from './useCurrentAuth'
import useRetailerAccountSlugFromRoute from './useRetailerAccountSlugFromRoute'

function useCurrentRetailerAccount() {
  const { retailerAccounts } = useCurrentAuth()
  const retailerAccountSlug = useRetailerAccountSlugFromRoute()

  const currentRetailerAccount = useMemo(() => {
    if (!retailerAccountSlug) {
      return undefined
    }

    return retailerAccounts.find((retailerAccount) => {
      return retailerAccount.slug === retailerAccountSlug
    })
  }, [retailerAccounts, retailerAccountSlug])

  return {
    currentRetailerAccount,
    get ensureCurrentRetailerAccount() {
      invariant(
        currentRetailerAccount,
        `Could not find retailer account for slug '${retailerAccountSlug}'`,
      )

      return currentRetailerAccount
    },
  }
}

export default useCurrentRetailerAccount
